'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('tvs_paddock', {
      url: '/tvs_paddock',
      template: '<tvspaddocktab></tvspaddocktab>',
      authenticate: 'admin'
    });
}
